import React, { useEffect } from "react";
import style from "./style";
import classNames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { v4 as uuid4 } from "uuid";

const useStyles = makeStyles(() => createStyles(style()));
type props = {
    appid: any;
    redirectURL: any;
    tenanturl: any;
    AuthGroup: any;
    scope:any;
    onMSResponse: any;
};

const MicrosoftAuth = (props: props): JSX.Element => {
    const classes = useStyles();

    useEffect(() => {
        const channel = new BroadcastChannel("ms-auth-channel");
        channel.onmessage = (event) => {
            props.onMSResponse({ code: event.data.code,scope:props.scope });
        };
        return () => channel.close();
    }, []);

    const generateCodeVerifier = (): string => {
        const array = new Uint8Array(32);
        window.crypto.getRandomValues(array);
        return btoa(String.fromCharCode(...array))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
    };

    const generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = await window.crypto.subtle.digest("SHA-256", data);
        return btoa(String.fromCharCode(...new Uint8Array(digest)))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
    };

    const openNewTab = async (): Promise<any> => {
        const code_verifier = generateCodeVerifier();
        localStorage.setItem("code_verifier", code_verifier);
        const codeChallenge = await generateCodeChallenge(code_verifier);
        const state = uuid4();
        const width = 599;
        const height = 599;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
        const tokenurl = `${props.tenanturl}/oauth2/v2.0/authorize` +
            `?client_id=${props.appid}` +
            "&response_type=code" +
            `&redirect_uri=${encodeURIComponent(props.redirectURL)}` +
            `&scope=${encodeURIComponent(props.scope)}` +
            "&response_mode=query" +
            `&state=${state}` +
            `&code_challenge=${codeChallenge}` +
            "&code_challenge_method=S256";
        window.open(tokenurl, "childwindow", features);
    };

    return (
        <div >
            <div className={classNames(classes.msLoginBtn)}>
                <div className={classNames(classes.iconCss)}>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="21" height="21" viewBox="0 0 48 48">
                        <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)"></path>
                        <path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)"></path>
                        <path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)"></path>
                        <path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)"></path>
                    </svg>
                </div>
                <div onClick={openNewTab} className={classNames(classes.labelCss)}>
                    Sign In with MicroSoft
                </div>
            </div>
        </div>
    );
};

export default MicrosoftAuth;